export const checkHasProfit = (value: number) => value >= 0;

export const formatChartValue = (value: number) => value.toFixed(2);
